import * as React from "react";
import { connect } from "react-redux";
import { Grid, Typography } from "@mui/material";
import SnackBar from "../components/SnackBarCustom";
import TableForm2 from "../components/TableForm2";
import { Creators as CreatorsConfig } from "../store/ducks/config";
import stock from "../assets/stock.png";
import { styles } from "../theme/styles";
function StockTienda2(props) {
  const { clearMessage, message } = props;
  return (
    <>
      <Grid style={styles.content2}>
        <Typography
          variant="h5"
          color="primary"
          height={"10%"}
          style={styles.title2}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#00205B"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M4 3m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
            <path d="M8 7m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z" />
            <path d="M8 14l0 .01" />
            <path d="M12 14l0 .01" />
            <path d="M16 14l0 .01" />
            <path d="M8 17l0 .01" />
            <path d="M12 17l0 .01" />
            <path d="M16 17l0 .01" />
          </svg>
          &nbsp; Visualización en tienda
        </Typography>
        <TableForm2 />
      </Grid>

      {message ? (
        <SnackBar
          message={message.text}
          variant={message.type}
          open={message ? true : false}
          onClose={clearMessage}
          time={3000}
        />
      ) : null}
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    message: state.config.message,
  };
};

const creators = {
  clearMessage: CreatorsConfig.clearMessage,
};

export default connect(mapStateToProps, creators)(StockTienda2);
